// import React, { useEffect, useRef, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
// import { markLectureAsComplete } from "../../../services/operations/courseDetailsAPI"
// import { updateCompletedLectures } from "../../../slices/viewCourseSlice"
// import { Player } from 'video-react';
// import "video-react/dist/video-react.css"
// import { BigPlayButton} from "video-react"
// import IconBtn from '../../common/IconBtn';



// const VideoDetails = () => {

//   const {courseId, sectionId, subSectionId} = useParams();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const playerRef = useRef();
//   const location  = useLocation();
//   const {token} = useSelector((state)=> state.auth);
//   const {courseSectionData, courseEntireData, completedLectures}= useSelector((state)=> state.viewCourse);

//   const [videoData, setVideoData] = useState([]);
//   const [videoEnded, setVideoEnded] = useState(false);
//   const [loading, setloading] = useState(false);


//   useEffect( () => {

//     const setVideoSpecificDetails = async() => {
//         if(!courseSectionData.length)
//           return;
//         if(!courseId && !sectionId && !subSectionId) {
//           navigate("/dashboard/enrolled-courses");
//         }else{
//           //lets assume all 3 fields are present
//           const filterData = courseSectionData.filter(
//             (course) => course._id === sectionId
//           )
//           const filterVideoData = filterData?.[0].subSection.filter(
//           (data) => data._id === subSectionId
//           )
//           setVideoData(filterVideoData[0]);
//           setVideoData(false);
//         }
//     }
//     setVideoSpecificDetails();

//   },[courseSectionData, courseEntireData, location.pathname])

//   const isFirstVideo = () => {
//     const currentSectionIndex = courseSectionData.findIndex(
//       (data) => data._id === sectionId
//     )

//     const currentSubSectionIndex = courseSectionData[currentSectionIndex].subSection.findIndex(
//       (data) => data._id === subSectionId
//     )
//     if(currentSectionIndex === 0 && currentSubSectionIndex ===0) {
//       return true;
//     }else{
//       return false;
//     }

//   }

//    const isLastVideo = () => {
//     const currentSectionIndex = courseSectionData.findIndex(
//       (data) => data._id === sectionId
//     )
//     const noOfSubSections = courseSectionData[currentSectionIndex].subSection.length;

//     const currentSubSectionIndex = courseSectionData[currentSectionIndex].subSectionId.findIndex(
//       (data) => data._id === subSectionId
//     )

//     if(currentSectionIndex === courseSectionData.length -1 && 
//       currentSectionIndex === noOfSubSections -1)  {
//         return true;
//       }else{
//         return false;
//       }
//   }


//    const goToNextVideo = () => {
//     const currentSectionIndex = courseSectionData.findIndex(
//       (data) => data._id === sectionId
//     )
//     const noOfSubSections = courseSectionData[currentSectionIndex].subSection.length;

//     const currentSubSectionIndex = courseSectionData[currentSectionIndex].subSection.findIndex(
//       (data) => data._id === subSectionId
//     )


//     if(currentSectionIndex !== noOfSubSections -1 ) {
//       //same section ki next video m jana h
//       const nextSubSectionId  = courseSectionData[currentSectionIndex].subSection[currentSectionIndex +
//          1]._id;
//          //iss video pr jana h
//          navigate(`/view-course/${courseId}/section/${sectionId}/sub-section/${nextSubSectionId}`)
//     }else{
//       //different section ki next video
//       const nextSectionId = courseSectionData[currentSectionIndex + 1]._id;
//       const nextSubSectionId = courseSectionData[currentSectionIndex + 1].subSection[0]._id;
//       //iss video pr jana h
//       navigate(`/view-course/${courseId}/section/${sectionId}/sub-section/${nextSubSectionId}`)
//     }
//   }
  
//    const goToPrevVideo = () => {
//      const currentSectionIndex = courseSectionData.findIndex(
//       (data) => data._id === sectionId
//     )
//     const noOfSubSections = courseSectionData[currentSectionIndex].subSection.length;

//     const currentSubSectionIndex = courseSectionData[currentSectionIndex].subSection.findIndex(
//       (data) => data._id === subSectionId
//     )

//     if(currentSubSectionIndex !== 0 ) {
//       //same sectino , prev video
//       const prevSubSectionId = courseSectionData[currentSectionIndex].subSection[currentSubSectionIndex - 1 ]  ;
//      //iss video p chale jao
//       navigate(`/view-course/${courseId}/section/${sectionId}/sub-section/${prevSubSectionId}`)
//     }else {
//       //different subSection Last video
//       const prevSectionId = courseSectionData[currentSectionIndex - 1]._id;
//       const prevSubSectionLength = courseSectionData[currentSectionIndex - 1].subSection.length;
//       const prevSubSectionId = courseSectionData[currentSectionIndex - 1].subSection[prevSubSectionLength - 1 ]._id;
//       //iss video p chale jao
//       navigate(`/view-course/${courseId}/section/${prevSectionId}/sub-section/${prevSubSectionId}`)
//     } 

//   }
//    const handleLectureCompletion = async() => {
//     //dummy code, baad m we will replace it with the actual call
//     setloading(true);
  
//     const res = await markLectureAsComplete({courseId: courseId,  subSectionId:subSectionId}, token)
//      //sate update
//      if(res){
//       dispatch(updateCompletedLectures(subSectionId));
//      }
//     setloading(false);
//   }



//   return (
//     <div>
//        {
//         !videoData ? (<div>
//           No Data Found
//         </div>) : (
//            <Player
//             ref={playerRef}
//             aspectRatio="16:9"
//             playsInline
//             onEnded={() => setVideoEnded(true)} 
//             src={videoData?.videoUrl}  
//             >  
//              <BigPlayButton position="center" />
//              {
//               videoEnded && (
//                 <div>
//                  {              
//                !completedLectures.includes(subSectionId) && (

//                <IconBtn 
//                 disabled={loading}
//                 onclick={() => handleLectureCompletion()}
//                 text={!loading ? "Mark as completed" : "Loading..."}
//                />
//                )
//                 }        
//                 <IconBtn 
//                   disabled={loading}
//                   onclick={() => {
//                     if(playerRef?.current){
//                       playerRef.current?.seek(0)
//                       setVideoEnded(false)
//                     }
//                   }}
//                   text="Rewatch" 
//                   customClasses='text-xl'
//                 />       

//               <div>
//                  {
//                   !isFirstVideo() && (
//                     <button
//                     disabled={loading}
//                     onclick={goToPrevVideo}
//                     className='blackButton'
//                     >
//                       Prev
//                     </button>
//                      )}

//                     {
//                     !isLastVideo() && (
//                       <button
//                       disabled={loading}
//                       onclick={goToPrevVideo}
//                       className='blackButton'>
//                        Next
//                       </button>
//                       )}
                 
//               </div>
//                  </div>
//               )
//              }

//              </Player>
//         )
//        }
//        <h1>
//         {videoData?.title}
//        </h1>
//        <p>
//         {videoData?.description}
//        </p>
//     </div>
//   )
// }

// export default VideoDetails


























import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"

import "video-react/dist/video-react.css"
import { useLocation } from "react-router-dom"
import { BigPlayButton, Player } from "video-react"

import { markLectureAsComplete } from "../../../services/operations/courseDetailsAPI"
import { updateCompletedLectures } from "../../../slices/viewCourseSlice"
import IconBtn from "../../common/IconBtn"

const VideoDetails = () => {
  const { courseId, sectionId, subSectionId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const playerRef = useRef(null)
  const dispatch = useDispatch()
  const { token } = useSelector((state) => state.auth)
  const { courseSectionData, courseEntireData, completedLectures } =
    useSelector((state) => state.viewCourse)

  const [videoData, setVideoData] = useState([])
  const [previewSource, setPreviewSource] = useState("")
  const [videoEnded, setVideoEnded] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    ;(async () => {
      if (!courseSectionData.length) return
      if (!courseId && !sectionId && !subSectionId) {
        navigate(`/dashboard/enrolled-courses`)
      } else {
        // console.log("courseSectionData", courseSectionData)
        const filteredData = courseSectionData.filter(
          (course) => course._id === sectionId
        )
        // console.log("filteredData", filteredData)
        const filteredVideoData = filteredData?.[0]?.subSection.filter(
          (data) => data._id === subSectionId
        )
        // console.log("filteredVideoData", filteredVideoData)
        setVideoData(filteredVideoData[0])
        setPreviewSource(courseEntireData.thumbnail)
        setVideoEnded(false)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseSectionData, courseEntireData, location.pathname])

  // check if the lecture is the first video of the course
  const isFirstVideo = () => {
    const currentSectionIndx = courseSectionData.findIndex(
      (data) => data._id === sectionId
    )

    const currentSubSectionIndx = courseSectionData[
      currentSectionIndx
    ].subSection.findIndex((data) => data._id === subSectionId)

    if (currentSectionIndx === 0 && currentSubSectionIndx === 0) {
      return true
    } else {
      return false
    }
  }

  // go to the next video
  const goToNextVideo = () => {
    // console.log(courseSectionData)

    const currentSectionIndx = courseSectionData.findIndex(
      (data) => data._id === sectionId
    )

    const noOfSubsections =
      courseSectionData[currentSectionIndx].subSection.length

    const currentSubSectionIndx = courseSectionData[
      currentSectionIndx
    ].subSection.findIndex((data) => data._id === subSectionId)

    // console.log("no of subsections", noOfSubsections)

    if (currentSubSectionIndx !== noOfSubsections - 1) {
      const nextSubSectionId =
        courseSectionData[currentSectionIndx].subSection[
          currentSubSectionIndx + 1
        ]._id
      navigate(
        `/view-course/${courseId}/section/${sectionId}/sub-section/${nextSubSectionId}`
      )
    } else {
      const nextSectionId = courseSectionData[currentSectionIndx + 1]._id
      const nextSubSectionId =
        courseSectionData[currentSectionIndx + 1].subSection[0]._id
      navigate(
        `/view-course/${courseId}/section/${nextSectionId}/sub-section/${nextSubSectionId}`
      )
    }
  }

  // check if the lecture is the last video of the course
  const isLastVideo = () => {
    const currentSectionIndx = courseSectionData.findIndex(
      (data) => data._id === sectionId
    )

    const noOfSubsections =
      courseSectionData[currentSectionIndx].subSection.length

    const currentSubSectionIndx = courseSectionData[
      currentSectionIndx
    ].subSection.findIndex((data) => data._id === subSectionId)

    if (
      currentSectionIndx === courseSectionData.length - 1 &&
      currentSubSectionIndx === noOfSubsections - 1
    ) {
      return true
    } else {
      return false
    }
  }

  // go to the previous video
  const goToPrevVideo = () => {
    // console.log(courseSectionData)

    const currentSectionIndx = courseSectionData.findIndex(
      (data) => data._id === sectionId
    )

    const currentSubSectionIndx = courseSectionData[
      currentSectionIndx
    ].subSection.findIndex((data) => data._id === subSectionId)

    if (currentSubSectionIndx !== 0) {
      const prevSubSectionId =
        courseSectionData[currentSectionIndx].subSection[
          currentSubSectionIndx - 1
        ]._id
      navigate(
        `/view-course/${courseId}/section/${sectionId}/sub-section/${prevSubSectionId}`
      )
    } else {
      const prevSectionId = courseSectionData[currentSectionIndx - 1]._id
      const prevSubSectionLength =
        courseSectionData[currentSectionIndx - 1].subSection.length
      const prevSubSectionId =
        courseSectionData[currentSectionIndx - 1].subSection[
          prevSubSectionLength - 1
        ]._id
      navigate(
        `/view-course/${courseId}/section/${prevSectionId}/sub-section/${prevSubSectionId}`
      )
    }
  }

  const handleLectureCompletion = async () => {
    setLoading(true)
    const res = await markLectureAsComplete(
      { courseId: courseId, subsectionId: subSectionId },
      token
    )
    if (res) {
      dispatch(updateCompletedLectures(subSectionId))
    }
    setLoading(false)
  }

  return (
    <div className="flex flex-col gap-5 text-white">
      {!videoData ? (
        <img
          src={previewSource}
          alt="Preview"
          className="h-full w-full rounded-md object-cover"
        />
      ) : (
        <Player
          ref={playerRef}
          aspectRatio="16:9"
          playsInline
          onEnded={() => setVideoEnded(true)}
          src={videoData?.videoUrl}
        >
          <BigPlayButton position="center" />
          {/* Render When Video Ends */}
          {videoEnded && (
            <div
              style={{
                backgroundImage:
                  "linear-gradient(to top, rgb(0, 0, 0), rgba(0,0,0,0.7), rgba(0,0,0,0.5), rgba(0,0,0,0.1)",
              }}
              className="full absolute inset-0 z-[100] grid h-full place-content-center font-inter"
            >
              {!completedLectures.includes(subSectionId) && (
                <IconBtn
                  disabled={loading}
                  onclick={() => handleLectureCompletion()}
                  text={!loading ? "Mark As Completed" : "Loading..."}
                  customClasses="text-xl max-w-max px-4 mx-auto"
                />
              )}
              <IconBtn
                disabled={loading}
                onclick={() => {
                  if (playerRef?.current) {
                    // set the current time of the video to 0
                    playerRef?.current?.seek(0)
                    setVideoEnded(false)
                  }
                }}
                text="Rewatch"
                customClasses="text-xl max-w-max px-4 mx-auto mt-2"
              />
              <div className="mt-10 flex min-w-[250px] justify-center gap-x-4 text-xl">
                {!isFirstVideo() && (
                  <button
                    disabled={loading}
                    onClick={goToPrevVideo}
                    className="blackButton"
                  >
                    Prev
                  </button>
                )}
                {!isLastVideo() && (
                  <button
                    disabled={loading}
                    onClick={goToNextVideo}
                    className="blackButton"
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          )}
        </Player>
      )}

      <h1 className="mt-4 text-3xl font-semibold">{videoData?.title}</h1>
      <p className="pt-2 pb-6">{videoData?.description}</p>
    </div>
  )
}

export default VideoDetails
// video